module.exports = __webpack_public_path__ + "fonts/DMSans-BoldItalic.a300c772.ttf";